import ControlButton from 'pages/Home/admin/ControlButton/ControlButton'
import Series from 'pages/Home/Series'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import AddRecordedWebinarDialog from './AddRecordedWebinarDialog'

export interface AddRecordedWebinarButtonProps {
  series: Series[]
}

export default function AddRecordedWebinarButton(props: AddRecordedWebinarButtonProps) {
  const { series } = props
  const [t] = useTranslation()
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const openWebinarDialog = () => setIsDialogOpen(true)
  const closeWebinarDialog = () => setIsDialogOpen(false)

  return (
    <>
      <ControlButton
        variant="add"
        title={t('home.recordedWebinarsSection.admin.addButton.tooltip')}
        onClick={openWebinarDialog}
      />
      {isDialogOpen && <AddRecordedWebinarDialog series={series} onRequestClose={closeWebinarDialog} />}
    </>
  )
}
